<script setup lang="ts">
import { mdiMenuDown } from '@quasar/extras/mdi-v7';
// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()

// defineEmits<{
//   // (event: 'update:modelValue', payload: string): void
// }>()

const model = defineModel<unknown>();
</script>

<template>
  <q-select
    v-model="model"
    filled
    no-error-icon
    :dropdown-icon="mdiMenuDown"
  />
</template>
